// Footer.js
import React from "react";
import "./Footer.css";
import {
  FaFacebookF,
  FaInstagram,
  FaSnapchatGhost,
  FaTiktok,
  FaTwitter,
  FaWhatsapp,
  FaApple,
  FaGooglePlay,
} from "react-icons/fa";

export default function Footer() {
  return (
    <footer className="footer-fthy">
      <div className="footerTop-fthy">
        <div className="footerTopInner-fthy">
          {/* Brand */}
          <div className="footerBrand-fthy">
            <div className="footerLogoRow-fthy">
              <span className="footerLogoText-fthy">Weltoc</span>
              <span className="footerLogoDot-fthy">.com</span>
            </div>
            <p className="footerTagline-fthy">Rapide et efficace.</p>
          </div>

          {/* Newsletter */}
          <div className="footerNews-fthy">
            <div className="footerNewsTitle-fthy">Soyez au courant de nos offres</div>
            <form className="footerNewsForm-fthy" onSubmit={(e) => e.preventDefault()}>
              <input
                className="footerNewsInput-fthy"
                type="email"
                placeholder="weltocapp@gmail.com"
                aria-label="Email"
                disabled={true}
              />
              {/* <button className="footerNewsBtn-fthy" type="submit">
                Souscrire <span className="footerNewsArrow-fthy" aria-hidden="true">›</span>
              </button> */}
            </form>
          </div>
        </div>
      </div>

      <div className="footerDivider-fthy" />

      {/* Links grid */}
      <div className="footerMid-fthy">
        <div className="footerMidInner-fthy">
          <div className="footerCol-fthy">
            <h4 className="footerColTitle-fthy">Shop By</h4>
            <a className="footerLink-fthy" href="/">Laptops &amp; Computers</a>
            <a className="footerLink-fthy" href="/">Chromebooks</a>
            <a className="footerLink-fthy" href="/">Desktops &amp; All in one</a>
            <a className="footerLink-fthy" href="/">Mobile &amp; Tablets</a>
            <a className="footerLink-fthy" href="/">Accessories</a>
            <a className="footerLink-fthy" href="/">Apple Products</a>
          </div>

          <div className="footerCol-fthy">
            <h4 className="footerColTitle-fthy">Renewed</h4>
            <a className="footerLink-fthy" href="/">Renewed Laptops</a>
            <a className="footerLink-fthy" href="/">Renewed mobiles</a>
            <a className="footerLink-fthy" href="/">Renewed Tablets</a>
            <a className="footerLink-fthy" href="/">Renewed Chromebook&apos;s</a>
            <a className="footerLink-fthy" href="/">Renewed Apple Products</a>
          </div>

          <div className="footerCol-fthy">
            <h4 className="footerColTitle-fthy">Information</h4>
            <a className="footerLink-fthy" href="/">Cancellation Policy</a>
            <a className="footerLink-fthy" href="/">Delivery policy</a>
            <a className="footerLink-fthy" href="/">EMI &amp; Payment</a>
            <a className="footerLink-fthy" href="/">Privacy Policy</a>
            <a className="footerLink-fthy" href="/">Return &amp; Refund</a>
            <a className="footerLink-fthy" href="/">Warranty Policy</a>
          </div>

          <div className="footerCol-fthy">
            <h4 className="footerColTitle-fthy">Weltoc</h4>
            <a className="footerLink-fthy" href="/">About Us</a>
            <a className="footerLink-fthy" href="/">Contact Us</a>
            <a className="footerLink-fthy" href="/">FAQ</a>
            <a className="footerLink-fthy" href="/">Terms &amp; Conditions</a>
            <a className="footerLink-fthy" href="/">Loyalty Program</a>
          </div>

          <div className="footerColApps-fthy">
            <h4 className="footerColTitle-fthy">Sur tous les ecrans</h4>

            <a className="footerStoreBtn-fthy" href="/" aria-label="App Store">
              <span className="footerStoreIcon-fthy" aria-hidden="true">
                <FaApple />
              </span>
              <span className="footerStoreText-fthy">
                <span className="footerStoreSmall-fthy"></span>
                <span className="footerStoreBig-fthy">App Store</span>
              </span>
            </a>

            <a className="footerStoreBtn-fthy" href="/" aria-label="Google Play">
              <span className="footerStoreIcon-fthy" aria-hidden="true">
                <FaGooglePlay />
              </span>
              <span className="footerStoreText-fthy">
                <span className="footerStoreSmall-fthy"></span>
                <span className="footerStoreBig-fthy">Google Play</span>
              </span>
            </a>
          </div>
        </div>
      </div>

      {/* Bottom blue bar */}
      <div className="footerBottom-fthy">
        <div className="footerBottomInner-fthy">
          <div className="footerHelp-fthy">
            <div className="footerHelpTitle-fthy">Nous sommes toujours là pour vous aider...</div>
            <div className="footerHelpSub-fthy">
              N’hésitez pas à nous contacter via nos différents canaux de support
            </div>
          </div>

          <div className="footerContactItem-fthy">
            <div className="footerContactLabel-fthy">Telephone:</div>
            <div className="footerContactValue-fthy">+228 93 41 08 27</div>
          </div>

          <div className="footerContactItem-fthy">
            <div className="footerContactLabel-fthy">Email:</div>
            <div className="footerContactValue-fthy">weltocapp@gmail.com</div>
          </div>

          <div className="footerSocialBlock-fthy">
            <div className="footerContactLabel-fthy">Connect with us</div>
            <div className="footerSocials-fthy">
              <a className="footerSocial-fthy" href="/" aria-label="Facebook">
                <FaFacebookF />
              </a>
              <a className="footerSocial-fthy" href="/" aria-label="Instagram">
                <FaInstagram />
              </a>
              <a className="footerSocial-fthy" href="/" aria-label="Snapchat">
                <FaSnapchatGhost />
              </a>
              <a className="footerSocial-fthy" href="/" aria-label="TikTok">
                <FaTiktok />
              </a>
              <a className="footerSocial-fthy" href="https://wa.me/+22893410827" aria-label="WhatsApp">
                <FaWhatsapp />
              </a>
            </div>
          </div>
        </div>

        <div className="footerCopy-fthy">
          <span>©2025 Weltoc All rights reserved</span>
          <span className="footerCopySep-fthy">|</span>
          <span>Powered by Weltoc.com</span>
        </div>
      </div>
    </footer>
  );
}
